import React, { useState, useEffect } from "react";
import { Typography, message, Divider, Table, Tag, Space } from "antd";
import { BulbOutlined, CalendarOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import http from "../../../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

// STATUS
const options_status = {
  [-1]: "Em formação",
  [0]: "Aguard. info.",
  [1]: "Ideia aceita",
  [2]: "Ideia c/ oportunidade",
  [3]: "Retorno de info.",
  [4]: "Em desenvolvimento",
  [5]: "Finalizado",
};

export const SugestoesSorteiosDetalhes = ({ idSorteio, dadosSorteio }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    if (idSorteio) {
      listarSugestoesParticipantes(idSorteio);
    }
  }, [idSorteio, dadosSorteio]);

  // LISTAR SUGESTÕES PARTICIPANTES
  const listarSugestoesParticipantes = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/sugestoes/listar_participantes_sorteio/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
      navigate("/sugestoes/sorteios");
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Sugestão",
      dataIndex: "titulo",
      sorter: (a, b) => a.titulo?.toString()?.localeCompare(b.titulo?.toString()),
    },
  ];

  return (
    <React.Fragment>
      <Space direction="vertical">
        <Text strong>
          <CalendarOutlined /> Período de Participação
        </Text>
        <Space wrap size={20}>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Início</Text>
            <Text>{dayjs(dadosSorteio?.data_inicio).format("DD/MM/YYYY")}</Text>
          </Space>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Fim</Text>
            <Text>{dayjs(dadosSorteio?.data_fim).format("DD/MM/YYYY")}</Text>
          </Space>
        </Space>
      </Space>

      <Divider />

      <Space direction="vertical">
        <Text strong>
          <UnorderedListOutlined /> Status Participantes
        </Text>
        <Space wrap size={5}>
          {dadosSorteio?.status_participantes?.split(",").map((e, index) => {
            return (
              <Tag code key={index}>
                {options_status[e]}
              </Tag>
            );
          })}
        </Space>
      </Space>

      <Divider />
      {dadosSorteio?.status === 0 && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Text strong>
            <BulbOutlined /> Ideias Participantes
          </Text>
          <Table rowKey="id" loading={loading} scroll={{ x: 700 }} columns={columns} dataSource={dados} size="small" />
        </Space>
      )}
    </React.Fragment>
  );
};
